import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getActivityByParty } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import type { Note } from '../../types';

import queryKeys from './../queryKeys';

export default function useNotes(
  partyId: string,
  id: string,
  options?: QueryOptions<Note>,
): UseQueryResult<Note, Error> {
  return useQuery({
    queryKey: queryKeys.byId(partyId, id),
    queryFn: async () => {
      const result = await getActivityByParty(
        {
          path: { party_id: partyId },
          query: { type: ['PARTY_NOTE_CREATED'] },
        },
        wgApi,
      );

      const note = (result as { items: Note[] }).items.find(
        (note) => note.activity_id === id,
      );

      if (!note) throw new Error('Not Found');

      return note;
    },
    ...options,
  });
}
